import * as tslib_1 from "tslib";
import { Tag } from '../../shared/models/tag.model';
/**
 * Tag that associates additional information with a business.
 */
var BusinessTag = /** @class */ (function (_super) {
    tslib_1.__extends(BusinessTag, _super);
    function BusinessTag() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * The active status of the tag
     */
    /**
     * Parses tag
     * @param data {any} Tag as returned by API
     * @return {Tag} Parsed tag
     */
    BusinessTag.parse = function (data) {
        var tag = Tag.parse(data);
        return Object.assign(tag, {
            businessTagId: data.businessTagId,
            businessId: data.businessId,
            isActive: data.isActive,
            sourceId: data.sourceId,
            updateDate: Date.parse(data.updateDate)
        });
    };
    return BusinessTag;
}(Tag));
export { BusinessTag };
